<div>
	@if (showForm()) {
		<nz-tabs [nzSelectedIndex]="selectedTabIndex()">
			<nz-tab [nzTitle]="edit() ? 'Edit Location' : 'Add Location'">
				<app-setup-wizard-location-form
					[loading]="loading()"
					[edit]="edit()?.after || edit()?.before || null"
					(onClear)="onFormClear()"
					(onSubmit)="onFormSubmit($event)"
				></app-setup-wizard-location-form>
			</nz-tab>
			@if (edit()) {
				<nz-tab nzTitle="Location Assignment">
					<app-setup-wizard-users-table
						[enableEditButton]="false"
						[enableToggleDisableButton]="false"
						[enableRemoveButton]="false"
						[enableResetButton]="false"
						[enableAssignButton]="true"
						[enableUnassignButton]="true"
						[pageSize]="2"
						[columnsFilter]="userTableColumns()"
						[selectedLocation]="edit()"
						(onAssign)="onAssign($event)"
						(onUnassign)="onUnassign($event)"
					></app-setup-wizard-users-table>
				</nz-tab>
			}
		</nz-tabs>
	} @else {
		<div class="top-buttons">
			<button nz-button nzType="primary" (click)="onAdd()" class="add-button">Add</button>

			<div>
				<app-setup-wizard-upload-csv-button></app-setup-wizard-upload-csv-button>

				<app-setup-wizard-download-csv-button
					[key]="SetupWizardPayloadObjectKeys.locations"
				></app-setup-wizard-download-csv-button>
			</div>
		</div>
	}
</div>
<div>
	<app-setup-wizard-locations-table
		[selectedRow]="edit()"
		(onEdit)="onEdit($event)"
		(onEditUsers)="onEditUsers($event)"
		(onToggleDisable)="onToggleDisable($event)"
		(onRemove)="onRemove($event)"
		(onReset)="onReset($event)"
	></app-setup-wizard-locations-table>
</div>
